// UI control type definitions for the inventory system

// Icon component props
export interface IconProps {
  size?: number;
  color?: string;
  className?: string;
}

// Button variants
export enum ButtonVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  OUTLINE = 'outline',
  DANGER = 'danger',
  GHOST = 'ghost'
}

// Button sizes
export enum ButtonSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large'
}

// Button props
export interface ButtonProps {
  children: React.ReactNode;
  variant?: ButtonVariant;
  size?: ButtonSize;
  isLoading?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  title?: string; // HTML title attribute (tooltip text)
}

// Modal props
export interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  size?: 'small' | 'medium' | 'large' | 'full';
  closeOnClickOutside?: boolean;
  id?: string;
}

// Tab item
export interface TabItem {
  id: string;
  label: string;
  content: React.ReactNode;
}

// Tabs props
export interface TabsProps {
  tabs: TabItem[];
  defaultTabId?: string;
  className?: string;
}

// Notification types
export enum NotificationType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info'
}

// Notification props
export interface NotificationProps {
  type: NotificationType;
  message: string;
  duration?: number;
  onClose?: () => void;
  className?: string;
}

/**
 * Enum defining barcode template options for different printing layouts
 */
export enum BarcodeTemplate {
  A = 'template_a', // Mirror barcode on both sides
  B = 'template_b', // Barcode on front, blank on back
  C = 'template_c', // Barcode on front, item details on back
  D = 'template_d', // Barcode on front, USD price on back
  E = 'template_e'  // Barcode on front, barcode ID string on back
} 